import { FlexAction } from '@/data/data-models';

export const actionNames = {
    SHOW: 'show',
    HIDE: 'hide',
    TOGGLE: 'toggle',
    TOGGLE_LAYERED_CONTAINER: 'toggleLayeredComponent',
    URL_REDIRECT: 'urlRedirect',
    SCROLL_INTO_FOCUS: 'scrollIntoFocus',
    SCROLL_TO_TOP: 'scrollToTop',
    FIRE_EVENT: 'fireEvent',
    RUN_ANIMATION: 'runAnimation',
    RUN_JAVASCRIPT: 'runJavascript',
    VALIDATE_FORM: 'validateForm',
    PAUSE: 'pause',
};

export default new Map([
    [actionNames.SHOW, new FlexAction({
        name: actionNames.SHOW,
        label: 'Show',
        component: 'action-show',
    })],

    [actionNames.HIDE, new FlexAction({
        name: actionNames.HIDE,
        label: 'Hide',
        component: 'action-hide',
    })],

    [actionNames.TOGGLE, new FlexAction({
        name: actionNames.TOGGLE,
        label: 'Toggle Display',
        component: 'action-toggle',
    })],

    [actionNames.TOGGLE_LAYERED_CONTAINER, new FlexAction({
        name: actionNames.TOGGLE_LAYERED_CONTAINER,
        label: 'Switch Layer',
        component: 'action-toggle-layered-container',
    })],

    [actionNames.URL_REDIRECT, new FlexAction({
        name: actionNames.URL_REDIRECT,
        label: 'Redirect to URL',
        component: 'action-url-redirect',
    })],

    [actionNames.SCROLL_INTO_FOCUS, new FlexAction({
        name: actionNames.SCROLL_INTO_FOCUS,
        label: 'Scroll into Focus',
        component: 'action-scroll-into-focus',
    })],

    [actionNames.SCROLL_TO_TOP, new FlexAction({
        name: actionNames.SCROLL_TO_TOP,
        label: 'Scroll to Top',
        component: 'action-scroll-to-top',
    })],

    [actionNames.FIRE_EVENT, new FlexAction({
        name: actionNames.FIRE_EVENT,
        label: 'Fire Event',
        component: 'action-fire-event',
    })],

    [actionNames.RUN_ANIMATION, new FlexAction({
        name: actionNames.RUN_ANIMATION,
        label: 'Run Animation',
        component: 'action-run-animation',
    })],

    [actionNames.RUN_JAVASCRIPT, new FlexAction({
        name: actionNames.RUN_JAVASCRIPT,
        label: 'Run Code',
        component: 'action-run-javascript',
    })],

    [actionNames.VALIDATE_FORM, new FlexAction({
        name: actionNames.VALIDATE_FORM,
        label: 'Validate Form',
        component: 'action-validate-form',
    })],

    [actionNames.PAUSE, new FlexAction({
        name: actionNames.PAUSE,
        label: 'Pause',
        component: 'action-pause',
    })],
]);
